import whichEnv from '@ally/which-env'

export const CATCH_ALL_ERROR_MESSAGE = `We can't complete your request right now. Try again later.`

export const env = whichEnv(window.location.href)

export const apigeeAPIKey = env.pick({
  dev: 'wU5VdAI4fv7jgsaAOJDREixc3MOaUs1R',
  cap: '7ZJ3GWuthDWEtZTJMbopIAHtctYdW4rT',
  fix: '7ZJ3GWuthDWEtZTJMbopIAHtctYdW4rT',
  qa1: 'A2t4hfS8ULZk5AQfdtVfQwkqi0tz9OHf',
  qa2: 'A2t4hfS8ULZk5AQfdtVfQwkqi0tz9OHf',
  qa3: 'A2t4hfS8ULZk5AQfdtVfQwkqi0tz9OHf',
  prod: 'XhnbsDYmBensf2vqVXAfv0uD7SJBA27u',
  local: 'wU5VdAI4fv7jgsaAOJDREixc3MOaUs1R',
})

export const HEADERS = {
  'API-KEY': apigeeAPIKey,
}

export const SERVER_TIMEZONE = 'America/New_York'

export interface ProductIdLookupObj {
  [key: number]: string
}

export const PRODUCT_ID_LOOKUP: ProductIdLookupObj = {
  4102: 'MMA',
  4107: 'OSA',
  4108: 'HYSA',
}

export interface AccountTypeLookupObj {
  [key: string]: string
}

export const INVEST_ACCOUNT_TYPES = ['INVW', 'INVA', 'INVS']

export const INVEST_ACCOUNT_TYPES_MAP: AccountTypeLookupObj = {
  INVW: 'Wealth Management', // this is used for analytics and will be updated to the new Personal Advice name in a later story
  INVA: 'Robo Portfolio', // this is used for analytics and may be updated to Automated Investing once discussed with analytics team
  INVS: 'Self-Directed',
}

export const BANK_ACCOUNT_TYPES = ['CHECKING', 'SAVINGS', 'CD', 'IRA']

export const BANK_ACCOUNT_TYPES_MAP: AccountTypeLookupObj = {
  CHECKING: 'Interest Checking',
  SAVINGS: 'Savings',
  CD: 'CDs',
  IRA: 'IRAs',
}

export const STALE_DATA_COPY =
  'We can’t update your account information right now, but we’re working on it.'
